import { IconProps } from '@/components/Icons/types/IconInterface';
import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';

interface RoundedExclamationIconProps extends IconProps {
  backgroundColor?: string;
}

const RoundedExclamationIcon = ({
  size,
  variant,
  className,
  backgroundColor
}: RoundedExclamationIconProps) => {
  return (
    <svg
      className={cn(iconVariant({ variant, size, className }))}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="35" cy="35" r="35" fill={backgroundColor ?? '#EF4A3C'} />
      <path
        d="M35.3535 44.1855C37.2312 44.1855 38.7537 45.7083 38.7539 47.5859C38.7539 49.4637 37.2313 50.9863 35.3535 50.9863C33.4759 50.9861 31.9531 49.4636 31.9531 47.5859C31.9533 45.7085 33.4761 44.1858 35.3535 44.1855Z"
        fill="white"
      />
      <path
        d="M35.3535 16.9863C37.2313 16.9863 38.7539 18.509 38.7539 20.3867V33.9863C38.7539 35.8641 37.2313 37.3867 35.3535 37.3867C33.4759 37.3865 31.9531 35.864 31.9531 33.9863V20.3867C31.9531 18.5091 33.4759 16.9865 35.3535 16.9863Z"
        fill="white"
      />
    </svg>
  );
};

export default RoundedExclamationIcon;
